import React, { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { LoadingSpinner } from '../../components'
import { getSessionResetPassword } from '../../utils/getSession'

export default function BrowseResetPassword() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()

  useEffect(() => {
    ;(async () => {
      const error = searchParams.get('success') === 'false'
      if (error) {
        const errorDescription = searchParams.get('message') || ''
        navigate(
          `/sso/browse/callback/error?error_description=${encodeURIComponent(errorDescription)}`,
          { replace: true },
        )
      } else {
        const redirectUrl = searchParams.get('redirect_url') || window.location.origin
        const basketId = searchParams.get('basket_id')
        if (basketId !== null) await getSessionResetPassword(basketId)
        window.location.replace(redirectUrl)
      }
    })()
  }, [])

  return (
    <div data-testid="browse-reset-password">
      <LoadingSpinner />
    </div>
  )
}
